import { render, staticRenderFns } from "./CategoryHubSkeleton.vue?vue&type=template&id=77166330&scoped=true"
import script from "./CategoryHubSkeleton.vue?vue&type=script&lang=js"
export * from "./CategoryHubSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CategoryHubSkeleton.vue?vue&type=style&index=0&id=77166330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77166330",
  null
  
)

export default component.exports